/**
 * Build an absolute media URL that never resolves under /admin/...
 * Encodes path segments so spaces/special characters work on Linux hosts.
 */
export function mediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }

  const envBase = (process.env.REACT_APP_API_URL || '')
    .replace(/\/api\/?$/, '')
    .replace(/\/$/, '');

  const origin =
    envBase ||
    (typeof window !== 'undefined' ? window.location.origin : '');

  let normalized = path.startsWith('/') ? path : `/${path}`;
  normalized = normalized.replace(/^\/admin(?=\/)/, '');

  if (!normalized.startsWith('/media/') && !normalized.startsWith('/storage/')) {
    normalized = `/media${normalized}`;
  }

  const parts = normalized.split('/').filter(Boolean);
  const head = parts[0]; // media|storage
  const encoded = parts
    .slice(1)
    .map((segment) => encodeURIComponent(decodeURIComponent(segment)))
    .join('/');

  return `${origin}/${head}/${encoded}`;
}

export function productImageSrc(product) {
  if (!product) return '';
  if (product.image) return mediaUrl(product.image);
  return product.image_url || '';
}

export function teamPhotoSrc(member) {
  if (!member) return '';
  if (member.profile_photo) return mediaUrl(member.profile_photo);
  return member.profile_photo_url || '';
}
